import { useEffect, useState } from "react";
import { Button, Table, Tag } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AuthenticationState } from "../../interfaces/users";
import { api } from "../../config";
import { SearchFilter } from "../Shared/Components/Filters/SearchFilter";
import {
  ModulePermission,
  userHasPermission,
} from "../../utils/helpers/userHelpers";

export const Municipalities = () => {
  const { token, user } = useSelector((state: AuthenticationState) => state);
  const [syncing, setSyncing] = useState(false);
  const {
    data: municipalities = [],
    isFetching,
    refetch,
  } = useQuery("municipalities", () =>
    api(token).get("/municipalities", { includeInactive: true })
  );
  const [tableData, setTableData] = useState<any[]>(municipalities);
  const userCanManageRegions = userHasPermission(user, {
    region_management: ModulePermission.ADMIN,
  });

  useEffect(() => {
    setTableData(municipalities);
  }, [municipalities]);

  const handleSync = async () => {
    try {
      setSyncing(true);
      await api(token).post("/municipalities/sync", {});
      toast.success("Municípios sincronizados com sucesso!");
      refetch();
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error ??
          "Ocorreu um erro ao sincronizar municípios"
      );
    } finally {
      setSyncing(false);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: 80,
    },
    {
      title: (
        <SearchFilter
          placeholder="Município"
          data={municipalities}
          setData={setTableData}
          field="name"
        />
      ),
      dataIndex: "name",
    },
    {
      title: "IBGE",
      dataIndex: "ibgeId",
    },
    {
      title: "UF",
      dataIndex: "stateCode",
      width: 90,
    },
    {
      title: "ID Estado IBGE",
      dataIndex: "stateIbgeId",
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (active: boolean) => (
        <Tag color={active ? "green" : "default"}>
          {active ? "Ativo" : "Inativo"}
        </Tag>
      ),
    },
  ];

  return (
    <div className="mt-4">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="mb-1">Municípios</h2>
          <p className="m-0">
            Base sincronizada a partir da API do IBGE. Não há edição manual.
          </p>
        </div>
        {userCanManageRegions ? (
          <Button
            type="primary"
            icon={<SyncOutlined />}
            loading={syncing}
            onClick={handleSync}
          >
            Sincronizar IBGE
          </Button>
        ) : null}
      </div>

      <Table
        rowKey="id"
        bordered
        loading={isFetching}
        dataSource={tableData}
        columns={columns}
        pagination={{ position: ["bottomCenter"] }}
      />
    </div>
  );
};
